import {
  CHANGE_EDITOR_FOCUS,
  SET_EDITOR_MODE,
  UPDATE_EDITOR_VISIBILITY,
  UPDATE_EDITOR_PINNED,
} from './types'

export const doChangeEditorFocus = isFocused => ({
  type: CHANGE_EDITOR_FOCUS,
  payload: { isFocused },
})

export const doSetEditorMode = mode => ({
  type: SET_EDITOR_MODE,
  payload: mode,
})

export function doUpdateEditorVisibility(isVisible) {
  return {
    type: UPDATE_EDITOR_VISIBILITY,
    payload: {
      isVisible,
    },
  }
}

export function doUpdateEditorPinned(isPinned) {
  return {
    type: UPDATE_EDITOR_PINNED,
    payload: {
      isPinned,
    },
  }
}
